import { render, staticRenderFns } from "./MosiaChat2.vue?vue&type=template&id=298316b6&scoped=true"
import script from "./MosiaChat2.vue?vue&type=script&lang=js"
export * from "./MosiaChat2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298316b6",
  null
  
)

export default component.exports